import styled, { css } from 'styled-components'

export const StyledScroll = styled.div`
  scrollbar-width: thin;
  scrollbar-color: ${props => props.theme.borderColor} transparent;

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 0.25rem;
  }
  &::-webkit-scrollbar-track:hover {
    background-color: ${props => props.theme.hoverBgLightestInverse};
  }
  &::-webkit-scrollbar-track:active {
    background-color: ${props => props.theme.bgDarkestInverse};
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(0 0 0 / 0.8);
    border-radius: 0.25rem;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${props => props.theme.primaryHover};
  }
  &::-webkit-scrollbar-thumb:active {
    background-color: ${props => props.theme.primaryHover};
  }
  &::-webkit-scrollbar-corner {
    background-color: ${props => props.theme.borderColor};
    border-radius: 0.25rem;
  }
  &::-webkit-scrollbar-corner:hover {
    background-color: ${props => props.theme.hoverBg};
  }
  &::-webkit-scrollbar-corner:active {
    background-color: ${props => props.theme.hoverBg};
  }

  &::-webkit-scrollbar {
    display: block;
    width: 0.5rem;
    height: 0.5rem;
  }
`

export const styledScrollMixin = css`
  scrollbar-width: thin;
  scrollbar-color: ${props => props.theme.borderColor} transparent;

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 0.25rem;
  }
  &::-webkit-scrollbar-track:hover {
    background-color: ${props => props.theme.hoverBgLightestInverse};
  }
  &::-webkit-scrollbar-track:active {
    background-color: ${props => props.theme.bgDarkestInverse};
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(0 0 0 / 0.8);
    border-radius: 0.25rem;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${props => props.theme.primaryHover};
  }
  &::-webkit-scrollbar-thumb:active {
    background-color: ${props => props.theme.primaryHover};
  }
  &::-webkit-scrollbar-corner {
    background-color: ${props => props.theme.borderColor};
    border-radius: 0.25rem;
  }
  &::-webkit-scrollbar-corner:hover {
    background-color: ${props => props.theme.hoverBg};
  }
  &::-webkit-scrollbar-corner:active {
    background-color: ${props => props.theme.hoverBg};
  }

  &::-webkit-scrollbar {
    display: block;
    width: 0.5rem;
    height: 0.5rem;
  }
`
